<template>
  <v-content>
    <v-container fluid>
      <Header :title="'Inbox'" />
       <Tutor :buttonName="'Book a Tutor'" />
      <v-row no-gutters>
      <v-row v-if='Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3))'>
        <v-col cols='12' md='4' sm='12'>
          <v-autocomplete
              v-model="selectedGroups"
              :items="groups"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(selectedUsers.length > 0? true : false)"
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-checkbox @change="checkboxUpdated('groups')" v-model="checkAllGroups" label="All"></v-checkbox>
              </v-list-item>
            </template>  
            </v-autocomplete>
        </v-col> 
        <v-col cols='12' md='4' sm='12'>
          <v-autocomplete
              v-model="selectedUsers"
              :items="users"
              item-value="user_id"
              :item-text="item =>`${item.name} (${item.email})`"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(selectedGroups.length > 0? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-checkbox @change="checkboxUpdated('users')" v-model="checkAllUsers" label="All"></v-checkbox>
            </v-list-item>
          </template>            
            
            </v-autocomplete>
        </v-col>       
        <v-col cols='12' md='4' sm='12'>
          <v-row class="mt-n3">
            <v-col cols="12" md="6" sm="12">
              <v-btn class="white--text" small :color="primary_color" @click="getInboxData()"  x-large block>
                {{ 'Search' | translate }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn class="white--text" small :color="primary_color" @click="clearFilter()"  x-large block>
                {{ 'Reset' | translate }}
              </v-btn>
            </v-col>
          </v-row>
             
        </v-col>
      </v-row> 
        <v-col cols="12">
        <v-tabs>
          <v-tab>{{ 'Items Board' | translate }}</v-tab>
          <v-tab>{{ 'Setup Items' | translate }}</v-tab>
          <v-tab-item>
            <DataTable v-if='!userdocuments.hasOwnProperty("stage_1") && !userdocuments.hasOwnProperty("stage_2")'  :title="title" :headers="headers" :items="userdocuments" :search="search" @openSettingsDialog='openSettingsDialog' @modalOpenDocument="documentOpenModal" />
            <DataTable v-if='userdocuments.hasOwnProperty("stage_1")' :title="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.user_documents : []" :search="stage1search" @openSettingsDialog='openSettingsDialog' @modalOpenDocument="documentOpenModal" :settingsstatus='valid' />
            <br /><br />
            <DataTable v-if='userdocuments.hasOwnProperty("stage_2")' :title="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.user_documents : []" :search="stage2search" @modalOpenDocument="documentOpenModal"  />
          </v-tab-item>
          <v-tab-item>
            <DataTable @modalOpenDocument="documentOpenModal"  :title="createdocumenttitle" :headers="createdocumentheaders" :items="createdocuments" :search="createsearch"  />
          </v-tab-item>

        </v-tabs> 

        <v-dialog v-model="settingsdialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ 'Set Filter'| translate }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 1'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      v-model="set_name_stage_1"
                      :disabled="isUser"
                      :rules="stage1name"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                     
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show next' | translate"
                      v-model="due_days_stage_1"
                      :disabled="isUser"
                      type="number"
                      :rules="duedays1"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                     
                    </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 2'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      :disabled="isUser"
                      v-model="set_name_stage_2"
                      :rules="stage2name"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template> 
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show from' | translate"
                      :disabled="isUser"
                      v-model="due_days_stage_2"
                      :rules="duedays2"
                      type="number"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template> 
                    </v-text-field>
                    </v-col>
                  </v-row>

                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="settingsdialog=false">{{ 'Close'| translate }}</v-btn>
              <v-btn color="blue darken-1" :disabled="isUser" text @click="clearsettings()">{{ 'Clear'| translate }}</v-btn>  
              <v-btn color="blue darken-1" :disabled="isUser" text @click="setFilter()">{{ 'Save'| translate }}</v-btn>              
            </v-card-actions>
          </v-card>
        </v-dialog>

      <v-dialog v-model="templatedialog" v-if="templatedialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline" v-if='editDocument'>{{ 'Edit document' | translate }}</v-card-title>
          <v-card-title class="headline" v-else>{{ 'Update document' | translate }}</v-card-title>
          <v-card-text>
              <v-card-text>
                <v-container>
                  <v-form id="modelform" ref="modelform">
                    <v-row>
                      <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                        <v-alert
                          dense
                          v-for="(v, k) in documenterrors"
                          :key="k"
                          outlined
                          type="error"
                        >{{ k }} {{ v }}</v-alert>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-autocomplete
                            v-model="status"
                            :items="statusvalues"
                            item-value="value"
                            item-text="text"
                            :label="'Status' | translate"
                            :rules="statusRules"
                            outlined
                            chips
                            small-chips
                            required
                            :no-data-text="$t('No data available')"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="true"

                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              :label="'Due date' | translate"
                              v-model="due_date"
                              name="due_date"
                              :rules="dateRules"
                              autocomplete="off"
                              required
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="due_date"
                            no-title
                            scrollable
                            :locale="curLanguage.lang_code"
                            @input="menu=false"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>

                    <v-row v-if="formMessage != null">
                      <v-col cols="12" sm="12" md="12">
                        <v-alert
                          dense
                          outlined
                          type="error"
                        >{{ formMessage | translate }}</v-alert>
                      </v-col>
                    </v-row>

                    <v-tabs v-if='editDocument ==false '>
                      <v-tab @click="customForm()">{{ 'File form' | translate }}</v-tab>
                      <v-tab v-if="showCustomForm()" @click="fileForm()">{{ 'Custom form' | translate }}</v-tab>
                      <v-tab-item>
                        <v-form id="fileformData" ref="fileformData">
                        <v-row class="mt-4">
                            <v-col cols="12" sm="12">
                                <v-file-input
                                    id="document_file"
                                    name="filename"
                                    outlined
                                    chips
                                    required
                                    :label="'Select file' | translate"
                                    :rules="fileRules"
                                    @change="onFileSelectedTemplate"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-file-input>
                            </v-col>  
                            <v-col cols="12" sm="12">
                              <v-textarea
                                outlined
                                name="comment"
                                v-model="comment"
                                autocomplete="off"
                                :label="'Comment (optional)' | translate"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                              </v-textarea>
                            </v-col>
                        </v-row>
                        </v-form>
                      </v-tab-item>
                      <v-tab-item v-if="showCustomForm()">
                        <v-form class="mt-4" id="customformData" ref="customformData">
                          <template v-for="(data,index) in metadatakeys">
                            <h3 :key="index" v-if="showCustomHeader(data)">{{ 'Page '+data }}</h3>
                            <v-row v-for="(metadata, indexvalue) of custommetadata[data]" :key="data+indexvalue+metadata.id">
                              <v-col cols="12" sm="12" md="12"  v-if ="metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'">
                                <v-text-field 
                                    v-if ="metadata.fieldName == 'short_text'"
                                    outlined
                                    type="text"
                                    :label="metadata.label"
                                    :id="data+indexvalue"
                                    autocomplete="off"
                                    required
                                    :rules="fieldRules"
                                    @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                <v-text-field 
                                    v-else-if ="metadata.fieldName == 'number'"
                                    outlined
                                    type="number"
                                    :label="metadata.label"
                                    :id="data+indexvalue"
                                    autocomplete="off"
                                    required
                                    min="0"
                                    :rules="fieldRules"
                                    @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                                <v-textarea
                                  v-else-if ="metadata.fieldName == 'long_text'"
                                  outlined
                                  :id="data+indexvalue"
                                  autocomplete="off"
                                  required
                                  :label="metadata.label"
                                  :rules="fieldRules"
                                  @keyup="saveMetaData(data,indexvalue,data+indexvalue)"
                                >
                                <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-textarea>
                              </v-col>
                            </v-row>
                          </template>
                          <v-row>
                            <v-col cols="12" sm="12">
                              <v-textarea
                                outlined
                                name="comment"
                                v-model="comment"
                                autocomplete="off"
                                :label="'Comment (optional)' | translate"
                              >
                              <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                              </v-textarea>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-tab-item>
                    </v-tabs>

                    <v-row v-if="editDocument">
                      <v-col cols="12" sm="12">
                        <v-textarea
                          outlined
                          name="comment"
                          v-model="comment"
                          autocomplete="off"
                          :label="'Comment (optional)' | translate"
                        >
                        <template #message="{ message }">
                          {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                        </template>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="closeBox()">{{ 'Close' | translate }}</v-btn>
            <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument()'>{{ 'Update' | translate }}</v-btn>
            <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>


<script>
import store from "@/store"
import { mapGetters, mapState  } from "vuex"
import { FETCH_USER_DOCUMENTS, UPDATE_USER_DOCUMENT, FETCH_USERS, FETCH_GROUPS, FETCH_CREATE_DOCUMENT, CLEAR_INBOX_SETTINGS,FETCH_INBOX_SETTINGS,SAVE_UPDATE_INBOX_SETTINGS } from "@/store/actions.type"
import { SET_LOADING, SET_ROUTER_ENTER, SET_SNACKBAR, SET_DOCUMENTS_ERROR } from "@/store/mutations.type"

export default {
  name: "Inbox",
  async beforeRouteEnter(to, from, next) {
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3)) {
      Promise.all([
        store.dispatch(FETCH_GROUPS, ""),
        store.dispatch(FETCH_USERS, ''),
      ]).finally(()=>{
          store.commit(SET_LOADING, false)
                  
      })
    }
    Promise.all([
      await store.dispatch(FETCH_USER_DOCUMENTS,'?status=active'),
      await store.dispatch(FETCH_CREATE_DOCUMENT,'initialize')
    ]).finally(()=>{
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)
    })

    return next();
  },
  data: function() {
    return {
      title: "Items Board",
      createdocumenttitle: 'Setup Items',
      search: "",
      createsearch: "",
      singleSelect: "",
      settingsdialog : false,
      set_name_stage_1: null,
      set_name_stage_2: null,
      due_days_stage_1: null,
      due_days_stage_2: null,
      stage1search: "",
      stage2search: "",
      valid: 'true',
      checkAllGroups: false,
      checkAllUsers: false, 
      selectedUsers: [],
      selectedGroups: [], 
      primary_color: '',
      isSearching: false,
      templatetitle: null,
      custommetadata: {},
      due_date: null,
      templatedialog: false,
      editDocument: false,
      doc_id: null,
      updateMessage: null,
      editMessage: null,
      updateSlug: null,
      main_template_id: null,
      metadatakeys:[],
      datacustom: {},
      formMessage: null,
      file: null,
      filetemplate: null,
      status: null,
      comment: null,
      menu: false,
    };
  },
  methods: {
    fileForm() {
      this.formMessage = null
      document.getElementById('document_file').value=''
      this.comment=''
      this.$refs.fileformData.reset()
      if(this.$refs.customformData != undefined) {
        this.$refs.customformData.reset()
      }
    },
    customForm () {
      this.formMessage = null
      this.comment = ''
      document.getElementById('document_file').value=''
      this.$refs.fileformData.reset()
      this.$refs.customformData.reset()
    },
    saveMetaData(index,internalindexvalue, id) {
      const value = document.getElementById(id).value
      this.custommetadata[index][internalindexvalue].value = value
    },
    showCustomHeader(customkey) {
      let status = false
      this.custommetadata[customkey].forEach(metadata =>{
        if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number'){
          status =true
        }
      })
      return status
    },
    onFileSelectedTemplate() {
      this.filetemplate = document.getElementById("document_file").files[0];
    },
    async getInboxData(){

    Promise.all([
      await store.dispatch(FETCH_USER_DOCUMENTS,'?status=active&user_ids='+this.selectedUsers+'&group_ids='+this.selectedGroups),
      await store.dispatch(FETCH_CREATE_DOCUMENT,'initialize?user_ids='+this.selectedUsers+'&group_ids='+this.selectedGroups)
    ]).finally(()=>{
        if(this.settingsdialog){
          this.set_name_stage_1 = ''
          this.due_days_stage_1  = ''
          this.set_name_stage_2 = ''
          this.due_days_stage_2 = ''                
          this.settingsdialog = false
          this.$refs.form.reset()
        }
        this.$store.commit(SET_LOADING, false);
        this.$store.commit(SET_ROUTER_ENTER, false)
    })
    },
    checkboxUpdated(flag){
      if(flag == "groups" && this.checkAllGroups){
          this.selectedGroups = []
          this.selectedGroups = this.groups.map(data=>data.group_id)
          this.selectedUsers = []
          this.checkAllUsers = false   
      }
      else if(flag=="groups" && this.checkAllGroups == false){
        this.selectedGroups = []
        this.selectedUsers = []
        this.checkAllUsers = false   
      }
      else if(flag == "users" && this.checkAllUsers){
        this.selectedUsers = []
        this.selectedUsers = this.users.map(data=>data.user_id)        
      }
      else if(flag== "users" && this.checkAllUsers == false){
        this.selectedUsers = []
      }

    },
    showCustomForm () {
      let status = false
      for(let data in this.custommetadata) {
        this.custommetadata[data].forEach(metadata => {
          if(metadata.fieldName == 'short_text' || metadata.fieldName == 'long_text' || metadata.fieldName == 'number') {
            status = true
          }
        })
      }
      return status
    },
    documentOpenModal (data) {
      const {title, templatedata, updateMessage, updateSlug } = data
      let currentDate = new Date()
      let validdate = new Date()
      if(templatedata.days_until != "---") {
        validdate.setDate(currentDate.getDate()+templatedata.days_until)
      }
      else{
        validdate.setDate(currentDate.getDate()+ 30)
      }
      this.due_date = validdate.toISOString().slice(0,10)
      this.templatetitle = title
      if(JSON.parse(templatedata.temp_file.temp_meta_data) !== null && typeof JSON.parse(templatedata.temp_file.temp_meta_data === "object")){
        this.metadatakeys = Object.keys(JSON.parse(templatedata.temp_file.temp_meta_data))
        this.custommetadata = JSON.parse(templatedata.temp_file.temp_meta_data)
      }
      this.main_template_id = templatedata.item_id
      this.doc_id= templatedata.temp_id
      this.comment  = templatedata.comment != undefined ? templatedata.comment : ''
      this.updateSlug = updateSlug
      this.updateMessage = updateMessage
      this.templatedialog = true
      this.status = templatedata.status
    },
    templateBoxClose () {
      this.templatetitle = '';
      this.custommetadata = {};
      this.due_date = null
      this.main_template_id = null
      this.doc_id= null
      this.updateSlug = ''
      this.updateMessage = ''
      this.templatedialog = false
      this.$store.commit(SET_DOCUMENTS_ERROR, [])
    },
    closeBox(){
      if(!this.editDocument) {
        document.getElementById('document_file').value=''
      }
      document.getElementById("modelform").reset();
      this.templatedialog = false
      this.editDocument = false
      this.status = null
      this.formMessage = null
    },
    async clearFilter(){
      this.checkAllGroups = false
      this.checkAllUsers = false      
      this.selectedGroups = []
      this.selectedUsers = []
      await this.getInboxData()
    },
    async openSettingsDialog(){
      await this.$store.dispatch(FETCH_INBOX_SETTINGS,'inbox').then( resp =>{
        if(resp.success){
          this.set_name_stage_1 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.set_name : "")
          this.set_name_stage_2 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.set_name : "")
          this.due_days_stage_1  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.due_days : "")
          this.due_days_stage_2  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.due_days : "")
          this.settingsdialog = true
          store.commit(SET_LOADING, false)
        }
      })      
    },
    closeSettingsDialog(){
      this.settingsdialog = false
      this.$refs.form.reset()      
      this.set_name_stage_1 = ''
      this.due_days_stage_1  = ''
      this.set_name_stage_2 = ''
      this.due_days_stage_2 = ''

    },
     clearsettings(){
     this.$store.dispatch(CLEAR_INBOX_SETTINGS,'inbox').then( async resp =>{
        if(resp.success){
            this.settingsdialog = false
            this.$refs.form.reset()                
            this.set_name_stage_1 = ''
            this.due_days_stage_1  = ''
            this.set_name_stage_2 = ''
            this.due_days_stage_2 = ''
            this.getInboxData()
        }
      })      
    },      
    uploadDocument () {
      if (this.$refs.modelform.validate()) {
          if(( this.$refs.customformData !=undefined  && this.$refs.customformData.validate()) || (this.$refs.fileformData !=undefined && this.$refs.fileformData.validate())) { 
            this.formMessage = null
          }
          else {
            this.formMessage = "Please fill custom form or file form completely"
            return ;             
          }

          var formData = new FormData(document.getElementById("modelform"));
          
          if(this.filetemplate != null && this.filetemplate != undefined && this.filetemplate != '') {
            formData.set("file", this.filetemplate)
          }
          else {
            formData.delete("file")
          }
          
          formData.set("item_id", this.main_template_id)
          formData.set("temp_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)

          if(this.filetemplate == null || this.filetemplate == undefined || this.filetemplate == '')
          formData.set('temp_meta_data',JSON.stringify(this.custommetadata))

          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  store.commit(SET_SNACKBAR, {status: true, message: this.updateMessage })
                  this.getInboxData()
                  this.$refs.modelform.reset()
                  this.templatedialog =false
                  this.doc_id = null
                  this.file=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.main_template_id = null
                  this.updateMessage = null
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
     setFilter(){
      if (this.$refs.form.validate()) {
         this.$store.dispatch(SAVE_UPDATE_INBOX_SETTINGS, {
          'stage_1':{ set_name: this.set_name_stage_1, due_days: this.due_days_stage_1 },
          'stage_2':{ set_name: this.set_name_stage_2, due_days: this.due_days_stage_2 }
        }).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') && resp.success){
            this.getInboxData()        
          }
          else{
            store.commit(SET_LOADING, false)
          }

        });

      }
    }
  },
  mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color

    if(this.currentUser.roles.includes(4) == true  && this.currentUser.is_group_user == false && company_meta.has_inbox == 'false'){
      this.$router.push('/dashboard')
    }
  },  
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Header: () => import("@/components/header/Header"),
    Tutor: () => import("@/components/modal/Tutor"),
  },
  computed: {
    ...mapGetters(["userdocuments","currentUser", 'users' ,'groups','createdocuments','inboxsettings','curLanguage']),
    ...mapState({
      documenterrors: state => state.documents.documenterrors
    }),
    headers(){ 
        return [
        { text: this.$t("Name"), value: "item_name" },   
        { text: this.$t("Template name"), value: "temp_name" },
        { text: this.$t("Type"), value: "temp_type" }, 
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "linktouser", sortable: false }
      ]
    },
    createdocumentheaders(){ 
        return [
        { text: this.$t("Name"), value: "item_name" },   
        { text: this.$t("Template name"), value: "temp_name" },
        { text: this.$t("Type"), value: "temp_type" }, 
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "createdocumentaction", sortable: false }
      ]
    },
    isUser(){
      return this.currentUser.roles.includes(1) && this.currentUser.roles.length == 1 ? false:true
    },     
    stage1name(){ return [v => !!v || "Name is required"]},
    stage2name(){ return [v => !!v || "Name is required"]},
    duedays1(){ return [v => !!v || "Due days is required"]},
    duedays2(){ return [v => !!v || "Due days is required"]},
    fieldRules() { return [v => !!v || "Field is required"]},
    fileRules() { return [
      v => !!v || 'File is required',
      v => (v && v.size > 0) || 'File is required',
    ]},
    statusRules(){ 
      return [v => !!v || "Status is required"]
    },
    dateRules(){ 
      return [v => !!v || "Date is required"]
    },
    statusvalues(){ 
      return [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ]
    }, 

  }
};
</script>